import { mapGetters } from "vuex";

export const taxTag = {
  computed: {
    ...mapGetters(["taxonomies", "targets"])
  },
  methods: {
    getTaxonomyLabel(taxonomyId) {
      for (var i = 0; i <= this.taxonomies.length; i++) {
        if(this.taxonomies[i].tax_id == taxonomyId) {
          return this.taxonomies[i].label;
        }
      }
    },
    getTargetLabel(targetId) {
      for (var i = 0; i <= this.targets.length; i++) {
        if(this.targets[i].gandtarget_id == targetId) {
          return this.targets[i].label;
        }
      }
    }
  }
}